import React from 'react';
import { View, ActivityIndicator, Platform, StyleSheet } from 'react-native';
import LottieView from 'lottie-react-native';
import theme from '@/constants/colors';

type Props = {
  size?: number;
  compact?: boolean;
};

export default function LottieLoader({ size = 200, compact = false }: Props) {
  // Web fallback
  if (Platform.OS === 'web') {
    if (compact) {
      return <ActivityIndicator size="small" color="#2563eb" />;
    }
    return (
      <View style={styles.center}>
        <ActivityIndicator size="large" color="#2563eb" />
      </View>
    );
  }

  const lottie = (
    <LottieView
      source={require('../assets/tail-trails-loader.json')}
      autoPlay
      loop
      style={{ width: size, height: size }}
      // 🛡️ Critical for New Arch Stability:
      // 'HARDWARE' prevents "drawing too large" errors on older Androids
      renderMode="HARDWARE"
      // Ensures the view doesn't render a black box if the first frame lags
      cacheComposition={true}
    />
  );

  if (compact) {
    return lottie;
  }

  return <View style={styles.center}>{lottie}</View>;
}

const styles = StyleSheet.create({
  center: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: 'stretch',
  },
});